import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { composeEmailActions } from '../actions/composeEmailActions';
import * as composeEmailAPI from '../api/composeEmail';

export const {
  composeEmailSend,
  composeEmailSendSucceeded,
  composeEmailSendFailed,
  composeEmailFindUser,
  composeEmailFindUserSucceeded,
  composeEmailFindUserFailed,
  composeEmailGetAllFrom,
  composeEmailGetAllFromSucceeded,
  composeEmailGetAllFromFailed,
  composeEmailGetDrafts,
  composeEmailGetDraftsSucceeded,
  composeEmailGetDraftsFailed,
  composeEmailSaveDraft,
  composeEmailSaveDraftSucceeded,
  composeEmailSaveDraftFailed,
  composeEmailRemoveDraft,
  composeEmailRemoveDraftSucceeded,
  composeEmailRemoveDraftFailed,
  composeEmailOpenModal,
  composeEmailSaveParentConv,
} = composeEmailActions;

export const composeEmail = [
  takeLatest(
    composeEmailSend.toString() as any,
    genWithPromise(
      composeEmailAPI.sendEmail,
      composeEmailSendSucceeded,
      composeEmailSendFailed,
    ),
  ),
  takeLatest(
    composeEmailGetDrafts.toString() as any,
    genWithPromise(
      composeEmailAPI.getDrafts,
      composeEmailGetDraftsSucceeded,
      composeEmailGetDraftsFailed,
    ),
  ),
  takeLatest(
    composeEmailSaveDraft.toString() as any,
    genWithPromise(
      composeEmailAPI.saveDraft,
      composeEmailSaveDraftSucceeded,
      composeEmailSaveDraftFailed,
    ),
  ),
  takeLatest(
    composeEmailRemoveDraft.toString() as any,
    genWithPromise(
      composeEmailAPI.removeDraft,
      composeEmailRemoveDraftSucceeded,
      composeEmailRemoveDraftFailed,
    ),
  ),
  takeLatest(
    composeEmailFindUser.toString() as any,
    genWithPromise(
      composeEmailAPI.findUser,
      composeEmailFindUserSucceeded,
      composeEmailFindUserFailed,
    ),
  ),
  takeLatest(
    composeEmailGetAllFrom.toString() as any,
    genWithPromise(
      composeEmailAPI.getAllFrom,
      composeEmailGetAllFromSucceeded,
      composeEmailGetAllFromFailed,
    ),
  ),
  takeEvery(composeEmailOpenModal.toString(), composeEmailOpenGen),
];

function genWithPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiAction, action.payload);
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}

function* composeEmailOpenGen(action: any) {
  const {
    payload: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      initialValues: { parentConversation: parentConversationID } = {},
    } = {},
  } = action;
  if (parentConversationID) {
    const getConversation = (state: any) => state.conversation.metaConversation;
    const parentConversation = yield select(getConversation);

    if (
      parentConversation &&
      parentConversation.conversation &&
      parentConversation.conversation.id === parentConversationID
    ) {
      yield put(composeEmailSaveParentConv({ parentConversation }));
    }
  }
}
